import React from 'react';
import {Button, Divider, message, Popconfirm, Table} from "antd";
import {deleteQa, getPagedQaList} from "../../../action/qa_action";
import {deleteNews} from "../../../action/news_action";

class QaList extends React.Component{
    static STATE_STRUCT = () => {
        return {
            listData: [],
            pageSize: 10,
            pageIndex: 0,
            total: 0,
            tableLoading: false,
        }
    };

    state = QaList.STATE_STRUCT();

    componentDidMount() {
        this._getData(0);
    }

    _getData = (pageIndex) => {
        this.setState({tableLoading: true});
        getPagedQaList(pageIndex, this.state.pageSize, (data, msg)  => {
            if (data) {
                this.setState({tableLoading: false, listData: data.data, total: data.size, pageIndex: pageIndex});
            } else{
                this.setState({tableLoading: false});
                message.error(msg ? msg : "获取Qa信息失败");
            }
        })
    };

    render() {
        const dataSource = this.state.listData;

        const columns = [
            {
                title: 'id',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: '日期',
                dataIndex: 'date',
                key: 'date',
            },
            {
                title: '简介',
                dataIndex: 'desc',
                key: 'desc',
            },
            {
                title: '操作',
                key: 'device_status',
                render: (record) => (
                    <div>
                        <a onClick={()=>this.props.history.push("/qa/edit/" + record.id)}>编辑</a>
                        <Divider type='vertical'/>
                        <Popconfirm
                            title="是否确认删除?"
                            onConfirm={() => {
                                deleteQa(record.id, (res, msg) => {
                                    if (res) {
                                        message.success("删除成功");
                                        this._getData(this.state.pageIndex);
                                    }else
                                        message.error(msg ? msg : "删除失败");
                                });
                            }}
                            okText="是"
                            cancelText="否">
                            <a>删除</a>
                        </Popconfirm>
                    </div>
                )
            }
        ];
        return (
            <div>
                <Button onClick={() => this.props.history.push("/qa/add")}>添加qa</Button>
                <Table style={{marginTop: 20}} loading={this.state.tableLoading} columns={columns} dataSource={dataSource} rowKey={record=>record.id}
                       pagination={{
                           current: this.state.pageIndex + 1,
                           defaultPageSize: this.state.pageSize,
                           total : this.state.total,
                           onChange: (page, si) => {
                               this._getData(page - 1);
                           }
                       }} />
            </div>

        );
    }
}

export default QaList;
